import { render, staticRenderFns } from "./BookingFeeTypeForm.vue?vue&type=template&id=285ec0bf"
import script from "./BookingFeeTypeForm.vue?vue&type=script&lang=js"
export * from "./BookingFeeTypeForm.vue?vue&type=script&lang=js"
import style0 from "./BookingFeeTypeForm.vue?vue&type=style&index=0&id=285ec0bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports